const EMPTY_HTML_PATTERNS = ['', '<p></p>', '<p><br></p>', '<p><br/></p>']

export const normalizeHtml = (html: string): string => {
  const trimmed = html.trim()

  if (EMPTY_HTML_PATTERNS.includes(trimmed)) {
    return ''
  }

  return trimmed
}

export const isAllowedLinkHref = (href: string): boolean =>
  /^https?:\/\//i.test(href.trim())
